'use client'
import {SmallText, SanityImage, Button} from '@local/ui/components'

import {LinkInput, SanityImageType} from '@local/types'
import Link from 'next/link'

export interface TravelCategoryCardProps {
	title: string
	image: SanityImageType
	description: string
	link: LinkInput
	tag?: string
}

export const TravelCategoryCard = ({title, image, description, link, tag}: TravelCategoryCardProps) => {
	const getLinkByTitle = () => {
		if (title === 'Group Retreats') {
			return '/experiences?tripType=group-retreat'
		}
		if (title === 'Private Collection') {
			return '/experiences?tripType=private-collection'
		}
		if (title === 'Kaer for Business') {
			return '/experience/kaer-for-business'
		}
		return '/experiences'
	}
	return (
		<Link href={getLinkByTitle()}>
			<article className='relative w-[335px] mx-auto lg:mx-0 lg:w-auto '>
				<SanityImage
					image={image}
					width={372}
					height={465}
					desktopWidth={372}
					mobileWidth={335}
					className='lg:rounded-lg  rounded-md w-full object-cover lg-max:aspect-[335/500]' />
				<div className='absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center'>
					{tag &&
						<div className='absolute top-10 bg-black text-white px-8 py-4 rounded-[3px]'>
							<SmallText className='uppercase text-white text-12'>{tag}</SmallText>
						</div>}
					<h3 className=' lg:block text-white text-28 font-serif font-medium leading-tight tracking-tight mb-100'>{title}</h3>
				</div>
				<div className='py-10 flex-col items-center gap-12 px-12  hidden lg:flex'>
					<p className='font-[350] text-12 lg:text-14 text-grey-4 leading-normal tracking-snug text-center'>{description}</p>
					<Button variant='primary' className='w-fit text-12 font-medium' small href={getLinkByTitle()} label='Explore Options' />
				</div>
				{/* <h3 className='block lg:hidden text-18 font-serif font-medium text-center leading-tight tracking-tight mt-16 text-black'>{title}</h3> */}
			</article>
		</Link>
	)
}
